import { gtm } from 'marketing-tracker';
import baseTemplate from 'src/templates/base/default.hbs';

import flowStore from 'src/stores/flowStore';
import catContentStore from 'src/stores/catContentStore';
import registrationStore from 'src/stores/registrationStore';
import questionStore from 'src/stores/questionStore';

import RedirectNode from 'src/components/redirectNode';
import QuestionNode from 'src/components/questionNode';
import InputNode from 'src/components/inputNode';
import PageNode from 'src/components/pageNode';

import navigationBar from './navigationBar';

const NODE_MAPPING = { RedirectNode, QuestionNode, InputNode, PageNode };

export default class PPF {
  constructor(flowOptions) {
    this.flowOptions = flowOptions;

    gtm.load();
    document.body.innerHTML += baseTemplate(this.flowOptions);

    this.state = {
      currentNodeIndex: null,
      currentComponent: null
    };

    this.subscribeToAppState();
  }

  subscribeToAppState() {
    this.onStateChange = this.onStateChange.bind(this);

    flowStore.addChangeListener(this.onStateChange);
    questionStore.addChangeListener(this.onStateChange);
    catContentStore.addChangeListener(this.onStateChange);
    registrationStore.addChangeListener(this.onStateChange);
  }

  onStateChange() {
    if (this.state.currentNodeIndex !== flowStore.activeNodeIndex) this.instantiateNodeComponent();
    this.state.currentComponent.onStateChange();

    this.updateNavbarState();
  }

  /* updateNavbarState() updates navigation bar state.
  *  Navigation bar needs to know any state change, so that
  *  components inside navigation bar should re-render itself
  *  based on options, that are passed to navigationBar's methods
  */
  updateNavbarState() {
    const activeNode = flowStore.getActiveNode();
    const nodeOptions = activeNode.getOptions();
    const options = Object.assign({}, nodeOptions, this.flowOptions);

    navigationBar.appendButtons(options);
    navigationBar.updateProgress(options);
  }

  instantiateNodeComponent() {
    if (this.state.currentComponent) this.state.currentComponent.destroy();
    const { type } = flowStore.getActiveNode();
    this.state.currentComponent = new NODE_MAPPING[type]();
    this.state.currentNodeIndex = flowStore.activeNodeIndex;
  }
}
